module.exports = __webpack_public_path__ + "media/fonts/Roboto-MediumItalic-17d0cac04a3f124945e14d55323a71d5.ttf";